export default __webpack_public_path__ + "assets/icons/cn.86098f87.svg";